function buildPlaceMarkerElement({ label, ariaLabel }) {
  const container = document.createElement('div');
  container.className = 'location-pin upload-center-marker';
  container.setAttribute('role', 'img');

  if (ariaLabel) {
    container.setAttribute('aria-label', ariaLabel);
  }

  const dot = document.createElement('div');
  dot.className = 'location-pin-icon upload-center-marker__dot';
  container.appendChild(dot);

  if (label) {
    const labelElement = document.createElement('p');
    labelElement.className = 'location-pin-label upload-center-marker__label';
    labelElement.innerText = label;
    container.appendChild(labelElement);
  }

  return container;
}

export function createPlaceMarker({ map, center, label, ariaLabel }) {
  if (!map || !Array.isArray(center) || center.length !== 2) return null;

  const element = buildPlaceMarkerElement({ label, ariaLabel });

  return new mapboxgl.Marker({
    element,
    anchor: 'center',
  })
    .setLngLat(center)
    .addTo(map);
}

export function removePlaceMarkers(markers) {
  if (!Array.isArray(markers) || !markers.length) return [];

  markers.forEach((marker) => {
    if (marker && typeof marker.remove === 'function') {
      marker.remove();
    }
  });

  return [];
}
